<template>
  <div>
      <Header class="no-print" />
      <main class="container">
        <router-view></router-view>
      </main>
      <Footer />
      <button class="gototop" @click="gototop"><i class="fas fa-angle-up"></i></button>
  </div>
</template>

<script>
  import Header from '@/components/frontstage/Header.vue'
  import Footer from '@/components/frontstage/Footer.vue'
  import '@/assets/frontstage/scss/basic.scss'

  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {
      }
    },
    created() {
      const html = document.documentElement; // returns the html tag
      html.setAttribute('lang', 'zh-Hant-TW');
    },
    methods: {
      gototop (){
        let documentBody = document.querySelector('html');
        documentBody.scrollTop = 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-header {
    position: relative;
    line-height: 60px;
    color: #333;
    box-shadow: 0 4px 13px rgba(0, 0, 0, 0.12);
    z-index: 10;
  }
  /deep/ .el-submenu .el-icon-menu,
  /deep/ .el-submenu__title i {
    color: #fff;
  }
</style>
